import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "button"]

  connect() {
    this.dialogTargets.forEach((dialog) => {
      setTimeout(() => {
        dialog.classList.add("hidden")
      }, 5000)
    })

    this.buttonTargets.forEach((button) => {
      button.addEventListener("click", () => {
        const dialog = button.closest("[data-flash-target='dialog']")
        if (dialog) dialog.classList.add("hidden")
      })
    })
  }
}
